/* ==========================================================================
   whero-footer.js — link-column accordion toggle (mobile/tablet only)
   --------------------------------------------------------------------------
   Below 1080px each column heading is an interactive button that toggles
   the [hidden] attribute on its list panel. At ≥1080px the CSS makes the
   button non-interactive (pointer-events:none) so the heading reads as a
   plain label and the list is always visible.
   ========================================================================== */
(function () {
  'use strict';

  var mobileQuery;
  function onMobile() {
    if (!mobileQuery) mobileQuery = window.matchMedia('(max-width: 1079.98px)');
    return mobileQuery.matches;
  }

  function wireAccordions() {
    var buttons = document.querySelectorAll('[data-whero-footer-accordion]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.addEventListener('click', function (e) {
        if (!onMobile()) return;
        var b = e.currentTarget;
        var panelId = b.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        var isOpen = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
      });
    }

    // On breakpoint change, reset panel state so the layout is clean
    // regardless of what the user toggled at the other size.
    if (!mobileQuery) mobileQuery = window.matchMedia('(max-width: 1079.98px)');
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', function () {
        var panels = document.querySelectorAll('.whero-footer__col-list');
        var btns = document.querySelectorAll('[data-whero-footer-accordion]');
        if (!mobileQuery.matches) {
          for (var p = 0; p < panels.length; p++) panels[p].removeAttribute('hidden');
        } else {
          for (var q = 0; q < panels.length; q++) panels[q].setAttribute('hidden', '');
          for (var r = 0; r < btns.length; r++) btns[r].setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  function init() {
    wireAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
